import { ZusBalanceRowModel } from './zusData.model';

/**
 * Average balance of the pension accounts (first pillar, without subaccounts)
 * by birth year and gender.
 *
 * Source: ZUS, Department of Statistics and Actuarial Forecasting,
 * https://www.zus.pl/pl/praca-i-emerytura/emerytura/wynagrodzenie-i-emerytura/kwoty-emerytury
 *
 */

// TODO: Read the data from a file (?)
export const ZUS_ACCOUNT_BALANCES: ZusBalanceRowModel[] = [
  { birthYear: 1949, female: 34989.97, male: 29138.72 },
  { birthYear: 1950, female: 291883.59, male: 72370.52 },
  { birthYear: 1951, female: 294492.78, male: 76691.89 },
  { birthYear: 1952, female: 293772.5, male: 75604.46 },
  { birthYear: 1953, female: 179789.91, male: 59887.66 },
  { birthYear: 1954, female: 57278.6, male: 74244.91 },
  { birthYear: 1955, female: 59137.14, male: 81434.24 },
  { birthYear: 1956, female: 67916.03, male: 89353.82 },
  { birthYear: 1957, female: 70294.74, male: 94083.47 },
  { birthYear: 1958, female: 64119.35, male: 109686.82 },
  { birthYear: 1959, female: 57975.07, male: 127762.96 },
  { birthYear: 1960, female: 55405.47, male: 155895.6 },
  { birthYear: 1961, female: 100982.18, male: 473795.59 },
  { birthYear: 1962, female: 77024.26, male: 655468.02 },
  { birthYear: 1963, female: 97612.89, male: 611028.09 },
  { birthYear: 1964, female: 139116.61, male: 572812.67 },
  { birthYear: 1965, female: 196080.98, male: 527474.73 },
  { birthYear: 1966, female: 380328.41, male: 490098.88 },
  { birthYear: 1967, female: 443553.19, male: 457121.66 },
  { birthYear: 1968, female: 413876.66, male: 422535.78 },
  { birthYear: 1969, female: 373028.59, male: 381761.26 },
  { birthYear: 1970, female: 343171.32, male: 351584.65 },
  { birthYear: 1971, female: 310466.53, male: 326239.2 },
  { birthYear: 1972, female: 281875.97, male: 300412.64 },
  { birthYear: 1973, female: 259824.59, male: 278310.59 },
  { birthYear: 1974, female: 238310.85, male: 255899.99 },
  { birthYear: 1975, female: 220330.84, male: 235323.5 },
  { birthYear: 1976, female: 203824.11, male: 219088.46 },
  { birthYear: 1977, female: 186607.85, male: 201927.24 },
  { birthYear: 1978, female: 171141.18, male: 184786.8 },
  { birthYear: 1979, female: 158391.46, male: 172308.48 },
  { birthYear: 1980, female: 146501.77, male: 158976.88 },
  { birthYear: 1981, female: 136262.19, male: 147333.74 },
  { birthYear: 1982, female: 128429.72, male: 138555.79 },
  { birthYear: 1983, female: 120831.54, male: 130200.51 },
  { birthYear: 1984, female: 113390.62, male: 121565.11 },
  { birthYear: 1985, female: 105887.69, male: 113619.64 },
  { birthYear: 1986, female: 98499.48, male: 104042.72 },
  { birthYear: 1987, female: 90850.72, male: 96027.76 },
  { birthYear: 1988, female: 84791.35, male: 89061.88 },
  { birthYear: 1989, female: 78414.86, male: 82774.36 },
  { birthYear: 1990, female: 72715.91, male: 77177.78 },
  { birthYear: 1991, female: 67226.0, male: 70702.36 },
  { birthYear: 1992, female: 61368.29, male: 63804.09 },
  { birthYear: 1993, female: 56083.95, male: 57944.63 },
  { birthYear: 1994, female: 50982.51, male: 52464.1 },
  { birthYear: 1995, female: 45608.59, male: 46776.04 },
  { birthYear: 1996, female: 40303.61, male: 41891.2 },
  { birthYear: 1997, female: 34928.18, male: 37116.33 },
  { birthYear: 1998, female: 29561.35, male: 31800.02 },
  { birthYear: 1999, female: 23951.29, male: 26669.33 },
  { birthYear: 2000, female: 18624.11, male: 21731.62 },
  { birthYear: 2001, female: 14502.98, male: 18024.99 },
  { birthYear: 2002, female: 11217.88, male: 14323.54 },
  { birthYear: 2003, female: 8503.04, male: 10867.71 },
  { birthYear: 2004, female: 4297.67, male: 5509.66 },
];
